module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic-VariableFont_wght.5b315bd5.ttf";